module.exports = __webpack_public_path__ + "img/hotel-16.eb04a5fa.jpeg";